import { render, staticRenderFns } from "./SeminarEntryTop.vue?vue&type=template&id=645d71ec"
import script from "./SeminarEntryTop.vue?vue&type=script&lang=js"
export * from "./SeminarEntryTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports